import { FC } from "react";
import { COPAY_TABLE } from "src/constants/todos";

const CopayBucketTableHeader: FC = () => (
  <thead className="sticky-top z-1">
   
    <tr className="text-center">
      {COPAY_TABLE.map((header, i) => (
        <th
          key={i}>
          {header.label}
        </th>
      ))}
    </tr>
  </thead>
);

export default CopayBucketTableHeader;
